import classes from './BoxNumberCell.module.css'
import classesCell from './BodyCell.module.css'

const BoxNumberCell = ({text}) => {
    return <div className={classes.box_number_outer}>
        <div className={`${classes.box_number} ${classesCell.body_cell}`}>{text}</div>
    </div>
}

export default BoxNumberCell